import pathToUrl from './cms-path-to-url';

// map AEM props into what the FE is expecting
export default ({
  navigationLinks = [],
  navigationTitle,
  hideNavigationTitle,
  styleIds = [],
  ...props
} = {}) => {
  const label = {
    display: !!navigationTitle,
    hide: hideNavigationTitle,
    text: navigationTitle,
  };

  const hasSeeMore = !styleIds.includes('remove-see-more');
  const hasTitleWithThroughLine = !styleIds.includes('remove-title-line');
  const theme = styleIds.includes('white-background') ? 'white' : 'grey';

  const categories = navigationLinks.map(({ title, path, categoryId }) => {
    return categoryId ? { name: title, categoryId } : { name: title, url: pathToUrl(path) };
  });

  return {
    ...props,
    categories,
    hasSeeMore,
    hasTitleWithThroughLine,
    theme,
    label,
  };
};
